// Axios
import apiInstance from '../../utils/axios/apiInstance';
import authInstance from '../../utils/axios/authInstance';
import {encodeData} from '../../utils/url';

// Get Event By Slug
export const getSingleEvent = (unique_id: string) => {
  return apiInstance.get(`events/${unique_id}`);
}

// Edit Create Event
export const editEventService = (data: any, id: string) => {
  const {assigned_to, task_id} = data;

  const endpoint = assigned_to && task_id ? `/admin/events/${id}` : `/events/${id}`;

  return apiInstance.patch(endpoint, data);
}

// Edit Create Event
export const createEventService = (data: object) => {
  return apiInstance.post('/events', data);
}

// Get Events
export const getAllEvents = (page: number, per_page: number, category: string, search: string, admin?: boolean) => {
  const data : any = {
    page: page,
    per_page: per_page,
    category: category,
    title: search
  };
  const params = encodeData(data);
  
  return admin ? apiInstance.get(`/admin/events?${params}`) : authInstance.get(`/events?${params}`);
};

// Get Expired Events
export const getExpiredEventsService = (page: number, per_page: number, category: string, search: string) => {
  const data : any = {
    page: page,
    per_page: per_page,
    category: category,
    title: search
  };
  const params = encodeData(data);
  return authInstance.get(`/expired-events?${params}`);
};

// Get Similiar Events
export const getSimiliarEvents = (category: string, unique_id: string, page: number, per_page: number) => {
  const data = {
    category: category,
    unique_id: unique_id,
    page: page,
    per_page: per_page,
  }
  const params = encodeData(data);

  return authInstance.get(`/similar-events?${params}`);
}

// Get Companies
export const getCompaniesProfiles = () => {
  return apiInstance.get('/profile/companies');
}

// Cities
export const getCitiesService = (data: string) => {
  return apiInstance.get(`/get-cities/${data}`);
}

// Get packages
export const getPackagesService = () => {
  return apiInstance.get(`/profile/packages?type=event`);
}

// Delete news
export const deleteEventService = (id: string) => {
  return apiInstance.delete(`/admin/events/${id}`);
}

